<template>
  <main class="login-page">
    <LanguageChoice />
    <div class="container">
      <div id="prForm"
           class="form"
      >
        <form v-if="type == 'SignIn'"
              action="#"
              class="login-form"
              @submit.prevent="login(username, password)"
        >
          <input v-model="username"
                 type="text"
                 name="username"
                 :placeholder="$t('loginPage.email')"
                 @change="setUsername"
          >
          <input v-model="password"
                 type="password"
                 name="password"
                 :placeholder="$t('loginPage.password')"
                 @change="setPassword"
          >
          <button type="submit"
                  class="btn"
          >
            {{ $t("loginPage.login") }}
          </button>
          <a type="submit"
             class="forgot-password-link"
             @click="handleForgotPassword"
          >{{ $t("loginPage.forgotPassword") }}</a>
        </form>
        <form v-if="type == 'ForgotPassword'"
              action="#"
              class="passwordReset-form"
              @submit.prevent="resetPassword"
        >
          <input v-model="email"
                 type="text"
                 name="email"
                 :placeholder="$t('loginPage.email')"
                 @change="setUsername"
          >

          <button type="button"
                  class="btn"
                  @click="resetPasswordClick()"
          >
            {{ $t("loginPage.resetPassword") }}
          </button>
          <a type="submit"
             class="forgot-password-link"
             @click="handleForgotPassword"
          >{{ $t("loginPage.backToLogin") }}</a>
        </form>
      </div>
    </div>
  </main>
</template>

<script setup>
import LanguageChoice from "../components/LanguageChoice.vue";
import { useStore } from "vuex";
import { computed } from "vue";

//VueX
const store = useStore();

const username = computed(() => store.state.login.username);
const password = computed(() => store.state.login.password);
const type = computed(() => store.state.login.type);

const setUsername = (x) => store.commit("login/setUsername", x.target.value);
const setPassword = (x) => store.commit("login/setPassword", x.target.value);
const login = () => store.dispatch("login/handleLoginSubmit");
const handleForgotPassword = () => store.dispatch("login/handleForgotPassword");
const resetPasswordClick = () => store.dispatch("login/resetPassword")

</script>


<style lang="scss" scoped>
@import "../scss/buttons.scss";
@import "../scss/input.scss";

@mixin message($fontcolor: #90a4ae) {
  color: $fontcolor;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
}



.passwordReset-form {
  width: 100% !important;
}

#prForm {
  max-width: 400px;
  //width: 392px;
}
.login-page {
  height: 100vh;
  overflow-y: scroll;
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
}

.form .btn[data-v-26084dc2] {
  margin: 25px 0px 15px 0px;
}

.disabled {
  margin-top: 5px;
  background-color: grey !important;
  cursor: not-allowed;
}
.forgot-password-link {
  cursor: pointer;
  text-decoration: underline;
}
.forgot-password-link:hover {
  color: darkblue;
}

.container {
  padding: 8% 0 0;
  width: 365px;
  margin: auto;
}

.form {
  position: relative;
  z-index: 1;
  max-width: 350px;
  margin: 0 auto 100px;
  padding: 45px;
  background: #ffffff;
  border-radius: 20px;
}
.btnSU {
  margin-top: 10px;
}
.form {
  input {
    @include input100percent;
  }

  .btn {
    @include btn100percent;
  }

  .message {
    @include message;

    a {
      text-decoration: none;
      color: #00bfa5;
    }
  }
}

.form .register-form {
  display: none;
}

@media (max-width: 768px) {
  .container {
    padding: 8% 0 0;
    width: 265px;
    margin: auto;
  }

  .form {
    position: relative;
    z-index: 1;
    max-width: 250px;
    margin: 0 auto 100px;
    padding: 25px;
    background: #ffffff;
    border-radius: 20px;
  }
}
</style>
